import { c as _c } from "react/compiler-runtime";
import { SearchClient, algoliasearch } from 'algoliasearch';
import { ReactElement, ReactNode, createContext, useContext } from 'react';
const searchClient = algoliasearch(process.env.NEXT_PUBLIC_ALGOLIA_APP_ID ?? '', process.env.ALGOLIA_SERVER_API_KEY ?? process.env.NEXT_PUBLIC_ALGOLIA_API_KEY ?? '');
const InstantSearchContext = createContext<SearchClient>(searchClient);
interface InstantSearchProviderProps {
  children: ReactNode;
  initialState?: SearchClient;
}
export function InstantSearchProvider(t0) {
  const $ = _c(2);
  const {
    children
  } = t0;
  let t1;
  if ($[0] !== children) {
    t1 = <InstantSearchContext.Provider value={searchClient}>{children}</InstantSearchContext.Provider>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}
export function useInstantSearchClient() {
  const context = useContext(InstantSearchContext);
  if (context === undefined) {
    throw new Error("useInstantSearch must be used within a InstantSearchProvider");
  }
  return context;
}